import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { IndexRegionsResponse } from "../response/RegionResponse";

interface RegionFilterProps {
    id?: string;
    name?: string;
}

interface IndexRegionsProps {
    filters?: RegionFilterProps;
    search?: string;
    orderBy?: string;
    sort?: 'asc' | 'desc';
    limit?: number;
    page?: number;
    all?: boolean;
}

const useIndexRegions = (query: IndexRegionsProps) => {
    return useQuery({
        queryKey: ['regions', query],
        queryFn: async () => {
            try {
                const params: Record<string, any> = {
                    'filter[id]': query.filters?.id,
                    'filter[name]': query.filters?.name,
                    search: query.search,
                    orderBy: query.orderBy ?? 'created_at',
                    sort: query.sort ?? 'desc',
                    limit: query.limit ?? 10,
                    page: query.page,
                    all: query.all ? 1 : undefined,
                };

                // Clear undefined and null values
                Object.keys(params).forEach(key =>
                    (params[key] === undefined || params[key] === null) && delete params[key]
                );

                const response = await privateApi.get(`/v4/region`, { params });

                const validationResult = IndexRegionsResponse.safeParse(response.data);
                if (!validationResult.success) {
                    console.error("Region API Validation Failed:", validationResult.error.errors);
                    throw new Error("Invalid regions data format received from the server.");
                }

                return validationResult.data;
            } catch (error) {
                console.error("Failed to fetch regions:", error);
                throw error;
            }
        },
        retry: 1,
        refetchOnWindowFocus: false,
    });
};

export default useIndexRegions;
